import React from 'react';
import '../../styles/ExchangeList.scss';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {Fab} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {formatCurrency} from "../../utils";

import ExchangeListItem from './ExchangeListItem';

function OverallStatus({exchanges}) {
  let remaining = 0;
  if (exchanges.length) {
    remaining = exchanges[0].totalRemaining
  }

  return <div className="overall-status">
    <span className="label">Remaining:</span>
    <span className="value">{formatCurrency(remaining, 'LBP')}</span>
  </div>;
}

function ExchangeListLoading() {
  const row = <div className="exchange-row">
    <span className="date"><Skeleton width="25%"/></span>
    <span className="amount-origin"><Skeleton width="75%"/></span>
    <span className="amount-conversion"><ArrowRightAltIcon fontSize="large" /></span>
    <span className="amount-rate"><Skeleton width="75%"/></span>
    <span className="amount-result"><Skeleton width="75%"/></span>
    <span className="amount-used"><Skeleton width="75%"/></span>
  </div>;
  return <>
    {row}
    {row}
    {row}
    {row}
    {row}
    {row}
    </>
}
function ExchangeList({data, isLoading}) {
  return <div className="exchange-list">
    {data && !isLoading
      ? <>
          <OverallStatus exchanges={data} />
          {data.map((r) => <ExchangeListItem key={r.rowNumber} item={r} />)}
        </>
      : <ExchangeListLoading/>}
    <Fab color="primary" aria-label="add" href="/exchanges/add" key="fab">
      <AddIcon />
    </Fab>
  </div>;
}

export default ExchangeList;
